// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const fetchFeatureFlagRequest = () => ({
    type: actionTypes.RA_FEATURE_FLAG_REQUEST,
});

const fetchFeatureFlagSuccess = data => ({
    type: actionTypes.RA_FEATURE_FLAG_SUCCESS,
    payload: {
        data,
    },
});

const fetchFeatureFlagFailure = error => ({
    type: actionTypes.RA_FEATURE_FLAG_FAILURE,
    payload: {
        data: error,
    },
});

const fetchFeatureFlag = () => dispatch => {
    dispatch(fetchFeatureFlagRequest());
    return APIGet(dispatch, apiURLBuilder.getURL('requestFeatureFlagging'))
        .then(response => {
            dispatch(fetchFeatureFlagSuccess(response));
        })
        .catch(error => {
            if (error.error) {
                dispatch(fetchFeatureFlagFailure(error));
            } else {
                throw error;
            }
        });
};

const featureModalToggle = () => ({
    type: actionTypes.RA_FEATURE_FLAG_MODAL_TOGGLE,
});

module.exports = {
    fetchFeatureFlag,
    featureModalToggle,
};
